import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  card: {
    display: 'flex',
    padding: '32px 41px',
    justifyContent: 'space-between',
    alignItems: 'center',
    maxWidth: '330px',
    minHeight: '370px',
  },
  row: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  avatar: {
    width: '120px',
    height: '120px',
    marginBottom: '8px',
  },

  avatarGroup: {
    margin: '24px 0',
    color: 'white',
  },

  statistic: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '80%',
    marginBottom: '64px',
  },

  price: {
    color: '#CACACA',
  },

  percent: {
    color: '#38EE7B',
    fontWeight: '500',
  },

  percentRed: {
    color: '#FF2424',
  },

  titleName: {
    fontWeight: '500',
    fontSize: '20px',
  },

  button: {
    width: '100%',
    '& button': {
      width: '100%',
    },
  },
});
